import React from 'react';

import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Select from '@material-ui/core/Select';
import PropTypes from 'prop-types';

const FeeSelect = props => (
  <FormControl fullWidth>
    <FormLabel htmlFor="fee">Gebühr</FormLabel>
    <Select
      native
      value={props.value}
      onChange={props.onChange}
      inputProps={{
                    id: 'fee',
                  }}
    >
      <option value="0">+ 0%</option>
      <option value={0.1}>+ 1%</option>
      <option value={0.2}>+ 2% (Typisch am Geldautomaten)</option>
      <option value={0.3}>+ 3% (Typisch für Kreditkarten)</option>
      <option value={0.4}>+ 4%</option>
      <option value={0.5}>+ 5% (Typisch im Wechselbüro)</option>
    </Select>
  </FormControl>

);

export default FeeSelect;

FeeSelect.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/calculator/FeeSelect.js